// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"745":"fe26b1e1ff819fb0","880":"dc3c7ef5d01b718a"}[chunkId] + ".js";
};